import * as z from "zod/v4";

export const DiscountProclivity = z.enum([
  "very_conservative",
  "conservative",
  "balanced",
  "aggressive",
  "very_aggressive",
]);

export type DiscountProclivity = z.infer<typeof DiscountProclivity>;

export const ShopperAgentDiscountConfigSchema = z.object({
  discountId: z.string().optional(),
  discountProclivity: DiscountProclivity.optional(),
});

export type ShopperAgentDiscountConfig = z.infer<
  typeof ShopperAgentDiscountConfigSchema
>;
